import ReactDOM from "react-dom";
import App from "./App";

import "./assets/scss/main.scss";

ReactDOM.render(<App />, document.getElementById("root"));

